import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.promise.js";
import { defineStore } from 'pinia';
import { apiGameInit } from '@/api/gameApi';
const themeList = {
  0: 'theme-dark',
  1: 'theme-light'
};
export const useGameStore = defineStore('game', {
  state: function () {
    return {
      gameList: [],
      currentGameId: 0,
      currentGameInfo: {},
      // 预检商品状态列表
      preCheckList: {},
      // vip等级描述图
      vipDescImg: '',
      //   角色ID图
      roleIdImg: '',
      // 是否开启会员等级
      levelFlag: false,
      isDisabledMall: -1,
      payRegions: []
    };
  },
  getters: {
    // 是否需要对商品预检
    preCheck: function (state) {
      var _state$currentGameInf;
      return ((_state$currentGameInf = state.currentGameInfo) === null || _state$currentGameInf === void 0 ? void 0 : _state$currentGameInf.preCheck) || false;
    },
    levelFlag: function (state) {
      var _state$currentGameInf2;
      return (_state$currentGameInf2 = state.currentGameInfo) === null || _state$currentGameInf2 === void 0 ? void 0 : _state$currentGameInf2.levelFlag;
    },
    currentTheme: function (state) {
      var _state$currentGameInf3;
      return themeList[(_state$currentGameInf3 = state.currentGameInfo) === null || _state$currentGameInf3 === void 0 ? void 0 : _state$currentGameInf3.theme] || 'theme-dark';
    }
  },
  actions: {
    setPayRegions(data) {
      this.payRegions = data;
    },
    setImgConfig(imgs) {
      this.vipDescImg = imgs.vipDescImg;
      this.roleIdImg = imgs.roleIdImg;
    },
    // 获取游戏配置
    async getGameInit(gameId) {
      this.isDisabledMall = -1;
      const res = await apiGameInit({
        mall_game_id: gameId
      });
      if (res.code !== 0) return;
      this.isDisabledMall = res.data.disable ? 0 : 1;
      this.currentGameInfo = _objectSpread(_objectSpread({}, res.data), {}, {
        orderExpireTime: res.data.orderExpireTime + 5000
      });
      document.body.className = 'theme-dark'; // themeList[res.data.theme] ||
    },
    setCurrentGameId(id) {
      this.currentGameId = id;
    },
    // 设置所有预检商品状态
    setPreCheckList(items) {
      this.preCheckList = items;
    }
  },
  persist: {
    key: '__mall__game__',
    storage: localStorage,
    paths: ['currentGameId', 'payRegions']
  }
});